
import * as React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import apps from 'src/display/apps';
import platform from 'src/display/platform';

export default function modulesRoute(version: '0.2' | '0.3') {
    if (version === '0.2') {
        return (
            <Switch>
                <Route path="/login" component={require('./Login').default} />
                <Route path="/guide" component={require('./Guide').default} />
                <Route path="/silent" component={require('./LoginSilent').default} />
                <Route path="/third" component={require('./LoginThird').default} />
                <Route path="/workbench" component={require('./Workbench').default} />
                <Route path="/companyRegister" component={apps.CompanyRegister} />
                <Route path="/network/companyregister" component={platform.CompanyRegister} />
                <Route path="/network/publicCompanyregister" component={platform.PublicCompanyRegister} />
                <Route path="/serviceagreement" component={require('./ServiceAgreement').default} />
                <Route path="/privacyagreement" component={require('./PrivacyAgreement').default} />
                <Route path="/modifypas/:email" component={require('./ModifyPas').default} />
                <Route path="/gettingStarted" component={platform.GettingStarted} />
                <Route path="/companyPublic/:companyId" component={require('./CompanyPublic').default} />
                <Route path="/preview" component={require('./PreviewPublic').default} />
                <Route render={() => <Redirect to="/login" />} />
            </Switch>
        );
    } else {
        return (
            <Switch>
                <Route path="/login" component={require('./Login').default} />
                <Route path="/guide" component={require('./Guide').default} />
                <Route path="/silent" component={require('./LoginSilent').default} />
                <Route path="/third" component={require('./LoginThird').default} />
                <Route path="/workbench" component={require('./Workbench2').default} />
                <Route path="/hide" component={require('./Workbench3').default} />
                <Route path="/companyRegister" component={apps.CompanyRegister} />
                <Route path="/network/companyregister" component={platform.CompanyRegister} />
                <Route path="/network/publicCompanyregister" component={platform.PublicCompanyRegister} />
                <Route path="/serviceagreement" component={require('./ServiceAgreement').default} />
                <Route path="/privacyagreement" component={require('./PrivacyAgreement').default} />
                <Route path="/modifypas/:email" component={require('./ModifyPas').default} />
                <Route path="/companyPublic/:companyId" component={require('./CompanyPublic').default} />
                <Route path="/gettingStarted" component={platform.GettingStarted} />
                <Route path="/preview" component={require('./PreviewPublic').default} />
                <Route render={() => <Redirect to="/login" />} />
            </Switch>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/modules/Home/Modules.Route.tsx